import React, {Component} from 'react';
import { List, InputItem, Button, WingBlank, Card, Badge, ActionSheet, Toast, Modal, Picker } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import iconAvatar from '../medias/logo.jpg';
import '../styles/KfHome.css';

class KfHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            profile: {},
            orderDetail: null,
            deviceTypes: [],
            enableSearch: true,
            enableGift: true,
            enableRefund: true,
            showGiftModal: false,
            showRefundModal: false,
            selectedItem: null
        }
    }

    componentDidMount() {
        this.loadInitData()
    }

    loadInitData = () => {
        this.loadProfile()
        this.loadDeviceTypes()
    }

    loadProfile = () => {
        DataFetcher.kfProfile({ 
            success: (resp) => {
                this.setState({
                    status: 'success',
                    profile: resp.data
                })
            }
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    handleSearchClick = () => {
        if(!this.state.enableSearch) {
            return
        }

        this.doSearch()
    }

    doSearch = () => {
        this.setState({
            enableSearch: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('search_') !== 0) {
                    continue
                }
                params[prop.substring('search_'.length)] = fieldsValue[prop]                
            }
            if(!params['orderNo']) {
                Toast.fail('请输入订单号')
                this.setState({
                    enableSearch: true
                })
                return
            }

            DataFetcher.kfSearchOrder(params, {
                success: (resp) => {
                    this.setState({
                        orderDetail: resp.data
                    })
                },
                completed: () => {
                    this.setState({
                        enableSearch: true
                    })
                }
            })
        })
    }

    handleItemClick = (rowData) => {
        const options = []
        if(rowData.operateType==='SOLD_CASH_PACKET' 
          || rowData.operateType==='SOLD_COUPON_PACKET' 
          || rowData.operateType==='SOLD_RECHARGE' 
          || rowData.operateType==='SOLD_COUPON') {
            options.push({ icon: <i className='iconfont icon-youxiyouxiji' style={{color:'#04bbc5', fontSize: 30}}/>, title: '赠送时间' })
        }
        if(rowData.canRefund&&rowData.refundStatus!=='SUCCESS') {
            options.push({ icon: <i className='iconfont icon-tuikuan' style={{color:'orange', fontSize: 30}}/>, title: '退款' })
        }

        if(!options.length) {
            Toast.info('不能操作团队提成订单')
            return
        }

        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: `${rowData.userNickName}  ${rowData.orderNo}`,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '赠送时间') {
                this.setState({
                    showGiftModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '退款') {
                this.setState({
                    showRefundModal: true,
                    selectedItem: rowData
                })
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleGiftClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableGift: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('gift_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableGift: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('gift_') !== 0) {
                    continue
                }
                params[prop.substring('gift_'.length)] = fieldsValue[prop]                
            }
            DataFetcher.kfGift(params, {
                success: (resp) => {
                    this.setState({
                        showGiftModal: false
                    })
                    //this.props.form.resetFields()
                    Toast.info('时间已送出')
                    this.doSearch()
                },
                completed: () => {
                    this.setState({
                        enableGift: true
                    })
                }
            })
        });
    }

    handleRefundClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableRefund: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('refund_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableRefund: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('refund_') !== 0) {
                    continue
                }
                params[prop.substring('refund_'.length)] = fieldsValue[prop]                
            }
            DataFetcher.kfRefund(params, {
                success: (resp) => {
                    this.setState({
                        showRefundModal: false
                    })
                    //this.props.form.resetFields()
                    Toast.info('退款处理中')
                    this.doSearch()
                },
                completed: () => {
                    this.setState({
                        enableRefund: true
                    })
                }
            })
        });
    }

    doResolveOrderType = (record) => {
        if(record.operateType === 'SOLD_CASH_PACKET') {
            return '游戏套餐(微信)'
        } else if(record.operateType === 'SOLD_COUPON_PACKET') {
            return '游戏套餐(余额)'
        } else if(record.operateType === 'SOLD_RECHARGE') {
            return '优惠充值'
        } else if(record.operateType === 'TEAM_SOLD_CASH_PACKET') {
            return '团队提成(游戏)'
        } else if(record.operateType === 'TEAM_SOLD_RECHARGE') {
            return '团队提成(充值)'
        } else if(record.operateType === 'SOLD_COUPON') {
            return '优惠活动'
        } else if(record.operateType === 'TEAM_SOLD_COUPON') {
            return '团队提成(活动)'
        }
    }

    doResolveOrderDevice = (record) => {
        if(CommonUtils.isNotEmpty(record.deviceName)) {
            return record.deviceName
        }

        if(CommonUtils.isNotEmpty(record.couponCode)) {
            return '优惠券' + record.couponCode
        }

        return '未知'
    }

    resolveJoinDaysInfo = (rowData) => {
        return CommonUtils.resolveJoinDaysInfo(rowData.userJoinDays)
    }

    generateHeaderView() {
        const { profile } = this.state;
        let brandName = BrandUtils.getCachedBrandName()
        if(CommonUtils.isEmpty(brandName)) {
            brandName = Constants.Strings.APP_NAME
        }

        return (
            <div className="section-header">
                <div className="container-left">
                    <div className="fl wrapper-avatar">
                        <img src={profile.avatar?profile.avatar:iconAvatar} alt=""/>
                    </div>
                    <div className="fl wrapper-basic">
                        <div className="name word-ellipsis">{CommonUtils.isEmpty(profile.name)?'游客':profile.name}</div>
                        <div className="brand word-ellipsis">{brandName}</div>
                    </div>
                </div>
                <div className='container-right'>
                </div>
            </div>
        )
    }

    generateSearchView = () => {
        const { getFieldProps } = this.props.form;
        const { enableSearch } = this.state

        return (
            <div className="section-search">
                <div className="title">
                    <i className='iconfont icon-shouye1' style={{fontSize:20}}></i>
                    <span> 订单查询</span>
                    <span className="sub"></span>
                </div>
                <div className="wrapper-content">
                    <List>
                        <InputItem style={{textAlign: 'center'}} placeholder='请输入订单号' {...getFieldProps('search_orderNo', {})}></InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleSearchClick} disabled={!enableSearch}>查询</Button>
                        </List.Item>
                    </List>
                </div>
            </div>
        )
    }

    generateOrderView() {
        const { orderDetail} = this.state
        let rowData = orderDetail
        if(!rowData) return

        let extra = (<div><span className='unit'>￥</span><span className='value'>{rowData.originalAmount}</span></div>)
        if(rowData.refundStatus === 'PROCESSING') {
            extra = (<Badge text="退款中"style={{backgroundColor: 'gray'}}/>)
        } else if(rowData.refundStatus === 'SUCCESS') {
            extra = (<Badge text="已退款"style={{backgroundColor: 'gray'}}/>)
        }

        let title = (<span className='word-ellipsis'>&nbsp;{rowData.userNickName}</span>)
        if(!rowData.newUser) {
            title = (<span className='word-ellipsis'>&nbsp;{rowData.userNickName} <Badge text="复购" style={{backgroundColor:'#04bbc5'}}/></span>)
        }

        return (
            <WingBlank size='lg'>
                <div className='order-view' onClick={() => {this.handleItemClick(rowData)}}>
                    <Card>
                        <Card.Header
                            title={title}
                            thumb={<img src={rowData.userAvatar} alt='avatar'/>}
                            extra={extra}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>订单类型：</span> 
                                    <span className='value'>{this.doResolveOrderType(rowData)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>套餐名称：</span> 
                                    <span className='value'>{rowData.orderName}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                {rowData.operateType==='SOLD_RECHARGE'||rowData.operateType==='TEAM_SOLD_RECHARGE'?(
                                    <div className='info-column word-ellipsis'>
                                        <span className='label'>赠送金额：</span> 
                                        <span className='value'>￥{rowData.giftAmount}</span>
                                    </div>
                                ):(
                                    <div className='info-column word-ellipsis'>
                                        <span className='label'>游戏时间：</span> 
                                        <span className='value'>{rowData.gameMinutes}分钟</span>
                                    </div>
                                )}
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>设备类型：</span> 
                                    <span className='value'>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>剩余时间：</span> 
                                    <span className='value'>{CommonUtils.readableGameMinutes(rowData.userGameMinutes)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>账户余额：</span> 
                                    <span className='value'>￥{rowData.userBalance}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>注册时间：</span> 
                                    <span className='value'>{this.resolveJoinDaysInfo(rowData)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>下单时间：</span> 
                                    <span className='value'>{CommonUtils.shortenDateTime(rowData.createTime)}</span>
                                </div>
                            </div>
                            {rowData.refundStatus==='FAIL'?(<div className='refund-tip word-ellipsis'>退款失败{rowData.refundRemark?'：'+rowData.refundRemark:''}</div>):null}
                        </Card.Body>
                        <Card.Footer content={<div className='tip' style={{paddingTop: 2}}><i className='iconfont icon-diannao' style={{fontSize: 10}}/>&nbsp;{this.doResolveOrderDevice(rowData)}</div>} extra={<span className='word-ellipsis'>{rowData.siteName}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderGiftModal = () => {
        const { getFieldProps } = this.props.form;
        const { showGiftModal, enableGift, selectedItem, deviceTypes } = this.state
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showGiftModal}
                    onClose={() => {
                        this.setState({showGiftModal: false})
                        //this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>赠送时间</div>}>
                        <InputItem disabled {...getFieldProps('gift_userNickName', {
                            initialValue: selectedItem?selectedItem.userNickName:null,
                        })}>
                            用户
                        </InputItem>
                        <Picker 
                            disabled
                            cols={1}
                            data={deviceTypePickerData}
                            {...getFieldProps('gift_deviceType', {
                                initialValue: selectedItem&&selectedItem.deviceType?[selectedItem.deviceType]:[],
                            })} 
                            >
                            <List.Item arrow="horizontal">类型</List.Item>
                        </Picker>
                        <InputItem disabled {...getFieldProps('gift_orderNo', {
                            initialValue: selectedItem?selectedItem.orderNo:null,
                        })}>
                            订单
                        </InputItem>
                        <InputItem type='number' extra="分钟" {...getFieldProps('gift_gameMinutes', {
                            initialValue: 15,
                            rules: [{required: true, message: '请填写时间'}],
                        })}>
                            时间
                        </InputItem>
                        <InputItem placeholder='请填写赠送时间原因' {...getFieldProps('gift_reason', {
                            rules: [{required: true, message: '请填写原因'}],
                        })}>
                            原因
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleGiftClick} disabled={!enableGift}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderRefundModal = () => {
        const { getFieldProps } = this.props.form;
        const { showRefundModal, enableRefund, selectedItem } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showRefundModal}
                    onClose={() => {
                        this.setState({showRefundModal: false})
                        //this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>退款</div>}>
                        <InputItem disabled {...getFieldProps('refund_userNickName', {
                            initialValue: selectedItem?selectedItem.userNickName:null,
                        })}>
                            用户
                        </InputItem>
                        <InputItem disabled {...getFieldProps('refund_orderNo', {
                            initialValue: selectedItem?selectedItem.orderNo:null,
                        })}>
                            订单
                        </InputItem>
                        <InputItem disabled type='number' extra="元" {...getFieldProps('refund_originalAmount', {
                            initialValue: selectedItem?selectedItem.originalAmount:null,
                        })}>
                            金额
                        </InputItem>
                        <InputItem placeholder='请填写退款原因' {...getFieldProps('refund_reason', {
                            rules: [{required: true, message: '请填写原因'}],
                        })}>
                            原因
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleRefundClick} disabled={!enableRefund}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderView() {
        return (
            <div className="page-kf-home">
                {this.generateHeaderView()}
                <Blank/>
                {this.generateSearchView()}
                <Blank/>
                <Blank/>
                {this.generateOrderView()}
                {this.doRenderGiftModal()}
                {this.doRenderRefundModal()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(KfHome);


// WEBPACK FOOTER //
// ./src/modules/KfHome.js